const list = {
  path: 'agentbanner',
  component: resolve => require(['@/pages/admin/platform/agentbanner'], resolve)
}

export default list
